import React from "react";
import { useState } from "react";
import { WalletController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { CreateInflowModal } from "../../pages";
import { date, number, object, string } from "yup";

const CreateInflowModalContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return object({
      currencyCode: string().required("Please select a Currency"),
      amountPaid: number()
        .min(1, "Amount cannot be less than 1")
        .required("Amount is required"),
      business: string().required("Please select a business"),
      transactionReference: string().required(
        "Transaction Reference is required"
      ),
      narration: string().required("Please enter narration"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      ...values,
    };

    delete payload.businessName;

    if (!payload.invoice) {
      delete payload.invoice;
    }

    if (!payload.invoiceNumber) {
      delete payload.invoiceNumber;
    }

    const { status, errorMessage } =
      await WalletController.createInflow(payload);

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({ message: status });
      return closeModal();
    }

    setLoading(false);
    return MimaToastUtil.error({ message: errorMessage });
  };

  return (
    <CreateInflowModal
      onSubmit={onSubmit}
      closeModal={closeModal}
      loading={loading}
      validationSchema={validationSchema}
    />
  );
};
export default CreateInflowModalContainer;
